var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#27A7E0",
    d: "M7.5 0a7.5 7.5 0 110 15 7.5 7.5 0 010-15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M8.256 6.72v4.668H6.609V6.72h1.647zM6.5 4.928c0-.127.024-.247.073-.36a.944.944 0 01.496-.495A.896.896 0 017.428 4c.127 0 .247.024.36.073a.944.944 0 01.495.496.896.896 0 01.073.359.896.896 0 01-.073.36.944.944 0 01-.496.495.896.896 0 01-.359.073.896.896 0 01-.36-.073.944.944 0 01-.495-.496.896.896 0 01-.073-.359z"
  }))));
};
export default __webpack_public_path__ + "static/media/info.0fde2162.svg";
export { SvgInfo as ReactComponent };